// apps/api/src/qxcircle/qxcircle-moderation-report.ts
// Description: QXCircle report post helper — keeps service under line cap.
// Owner: Masa Bayu
// Date: 2026-08-24

import { BadRequestException } from "./_nestjs-common";
import { isManagedQxCirclePost } from "./qxcircle-post-presenter";
import type {
  QxCircleFeedPost,
  QxCircleModerationItem,
  QxCircleModerationResponse,
  QxCircleReportResult,
} from "./qxcircle.types";

export function queueQxCircleReport(
  post: QxCircleFeedPost,
  reasonRaw: string,
  reports: QxCircleModerationItem[],
  hiddenPosts: Set<string>,
  reportSeq: number,
): { result: QxCircleReportResult; item: QxCircleModerationItem; nextSeq: number } {
  if (isManagedQxCirclePost(post)) {
    throw new BadRequestException("Cannot report your own post");
  }
  const reason = reasonRaw.trim();
  if (!reason) {
    throw new BadRequestException("Report reason required");
  }
  const nextSeq = reportSeq + 1;
  const item: QxCircleModerationItem = {
    id: `qxcircle_rpt_${nextSeq}`,
    postId: post.id,
    reason,
    status: "queued",
    createdAt: new Date().toISOString(),
  };
  reports.push(item);
  hiddenPosts.add(post.id);
  return {
    item,
    nextSeq,
    result: {
      postId: post.id,
      reason,
      status: "queued",
      note: "Report queued — post hidden locally (lab simulate, not prod moderation)",
    },
  };
}

export function buildQxCircleModerationQueue(
  reports: QxCircleModerationItem[],
): QxCircleModerationResponse {
  return {
    items: [...reports].sort(
      (a, b) => Date.parse(b.createdAt) - Date.parse(a.createdAt),
    ),
    world: "qxcircle",
    slice: "profile",
  };
}
